import React from 'react';
import Typography from '@mui/material/Typography';
import { Stack, Tooltip } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import { useSelector } from 'react-redux';
import { RootReducer } from '@store/index';
import { ProfileTypes } from '@api/Users/User';
import { getProfileName } from '@utils/Profiles';

// ============================================================================
// Contexto de trabajo en la barra superior — SOLO INFORMATIVO.
//
// Antes hacía `return null` para el admin: la sucursal quedaba oculta justo
// para el único perfil que puede cambiarla, y como el admin ahora trabaja en
// todas las pantallas sin cambiarse de perfil (2026-08-18), no saber sobre qué
// sucursal está parado es peligroso — el POS, el inventario y el tablero
// dependen de ella. Ahora se muestra SIEMPRE.
//
// ⚠️ Aquí NO se cambia de sucursal (decisión de Irving): el único lugar para
// cambiarla es el selector del sidebar. Esta barra solo dice dónde estás.
// ============================================================================

const BranchOfficeName: React.FunctionComponent = () => {
    const { loggedUser, profileSelected, branchOfficeSelected, distributionCenterSelected } = useSelector(
        (state: RootReducer) => state.auth
    );

    const isAdmin = loggedUser?.profile.profile === ProfileTypes.Admin;
    const isCedisView = profileSelected === ProfileTypes.DistributionCenter;

    if (isCedisView) {
        return (
            <Stack direction="row" alignItems="center" spacing={1}>
                <WarehouseIcon />
                {!isAdmin && <Typography>{`${getProfileName(profileSelected)} - `}</Typography>}
                <Typography>{distributionCenterSelected?.name || 'Sin centro de distribución'}</Typography>
            </Stack>
        );
    }

    return (
        <Tooltip title={isAdmin ? 'Sucursal en la que estás trabajando — cámbiala en el menú' : ''}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <StorefrontIcon />
                {!isAdmin && <Typography>{`${getProfileName(profileSelected)} - `}</Typography>}
                <Typography>{branchOfficeSelected?.name || 'Sin sucursal'}</Typography>
            </Stack>
        </Tooltip>
    );
};

export default BranchOfficeName;
